import { useParams } from "react-router-dom";
import UpdateUserForm from "../components/form/UpdateUserForm";
import { usePage } from "../contexts/PageProvider";
import { UPDATE_USER_URL } from '../contexts/PageProvider';

const UpdateUserPage = () => {
    const urlParams = useParams();
    const { pageData, setPageData } = usePage();
    if (pageData.url != UPDATE_USER_URL) {
        setPageData({url: UPDATE_USER_URL, title: "Fiche utilisateur"});      
    }

    return (
        <UpdateUserForm
            dataUrl={urlParams}
            submitButtonChildren={"modifier utilisateur"}
        />
    );
};

export default UpdateUserPage;